import { render, staticRenderFns } from "./DetailUserStaff.vue?vue&type=template&id=1b17d14d&"
import script from "./DetailUserStaff.vue?vue&type=script&lang=js&"
export * from "./DetailUserStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports